import { OWebPageBase, tPageRoute } from "oweb";
import PSectorComponent from "@/components/pages/PSector.vue";
import { VueConstructor } from 'vue';

export default class PSector extends OWebPageBase<VueConstructor> {
	getName() {
		return "PSector"
	}

	getRoutes(): tPageRoute[] {
		return [ {
			title: "",
			slug: "w-sector-companies",
			path: "/sectors/:id",
			pathOptions: {
				id: "num"
			}
		}, {
			title: "SX_LANG_SECTOR_EDIT",
			slug: "w-sector-edit",
			path: "/sectors/:id/edit",
			pathOptions: {
				"id": "num"
			}
		} ]
	}

	getComponent() {
		return PSectorComponent;
	}
}
